import { StatCard } from '@wundo/ui';
import type { UsageCostTotals } from '@/lib/usageCost.ts';
import { formatCurrency } from '@/utils/currencyUtils.ts';
import { formatCount, formatPercent, formatTokens } from './costFormat.ts';

/** The headline numbers of the window: what it cost, how much was used, and what is missing. */
export function CostTotals({ totals }: { totals: UsageCostTotals }) {
  const totalTokens =
    totals.input_tokens +
    totals.output_tokens +
    totals.cache_read_tokens +
    totals.cache_creation_5m_tokens +
    totals.cache_creation_1h_tokens;

  /* Share of input-side tokens that were served from cache. */
  const inputSide =
    totals.input_tokens +
    totals.cache_read_tokens +
    totals.cache_creation_5m_tokens +
    totals.cache_creation_1h_tokens;
  const cacheHitRate = inputSide === 0 ? 0 : totals.cache_read_tokens / inputSide;

  return (
    <div className='grid grid-cols-2 gap-4 mobile:grid-cols-3 agenda:grid-cols-5'>
      <StatCard label='Total cost' value={formatCurrency(totals.cost_usd)} />
      <StatCard label='Billed uses' value={formatCount(totals.calls)} />
      <StatCard label='LLM tokens' value={formatTokens(totalTokens)} />
      <StatCard label='Cache hit rate' value={formatPercent(cacheHitRate)} />
      <StatCard
        label='Unpriced uses'
        value={formatCount(totals.unpriced_calls)}
        hint={
          totals.unpriced_calls > 0
            ? 'No price on file — the total above is understated'
            : undefined
        }
      />
    </div>
  );
}
